<template>
  <v-select
    :items="items"
    :label="label"
    :hint="hint"
    :readonly="readonly"
    :value="value"
    :multiple="multiple"
    :rules="requiredRules"
    :class="styleClasses"
    item-text="label"
    item-value="value"
    @change="changeItem"
    @input="changeItem"
  >
  </v-select>
</template>
<script>
import { requiredRules } from '../../utils/rules'

export default {
  name: 'ValidationsSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    },
    items () {
      return [
        {
          label: this.$t('core.validationsselect.text'),
          value: 'IS_STRING'
        },
        {
          label: this.$t('core.validationsselect.int'),
          value: 'IS_INTEGER'
        },
        {
          label: this.$t('core.validationsselect.long'),
          value: 'IS_LONG'
        },
        {
          label: this.$t('core.validationsselect.float'),
          value: 'IS_FLOAT'
        },
        {
          label: this.$t('core.validationsselect.double'),
          value: 'IS_DOUBLE'
        },
        {
          label: this.$t('core.validationsselect.map'),
          value: 'IS_MAP'
        },
        {
          label: this.$t('core.validationsselect.list'),
          value: 'IS_LIST'
        },
        {
          label: this.$t('core.validationsselect.date'),
          value: 'IS_DATE'
        },
        {
          label: this.$t('core.validationsselect.null'),
          value: 'IS_NULL'
        },
        {
          label: this.$t('core.validationsselect.not_null'),
          value: 'IS_NOT_NULL'
        },
        {
          label: this.$t('core.validationsselect.lenght'),
          value: 'LENGTH'
        },
        {
          label: this.$t('core.validationsselect.regex'),
          value: 'REGEX'
        }
      ]
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    styleClasses: {
      type: String,
      default: null
    }
  }
}
</script>
